import * as types from "../types";

export const fetchBidStatusRequest = ({accessToken, product_id}) => ({
    type: types.FETCH_BID_STATUS_REQUEST,
    payload:{
        accessToken, 
        product_id
    }
});

export const fetchBidStatusSuccess = ({resFetBidStatus}) => ({
    type: types.FETCH_BID_STATUS_SUCCESS,
    payload:{
        resFetBidStatus
    }
});

export const fetchBidStatusFailure = ({error}) => ({
    type: types.FETCH_BID_STATUS_FAILURE,
    payload:{
        error:error.message
    }
});